import { LoadingButton } from '@mui/lab'
import { Stack } from '@mui/material'
import { resendWelcomeEmail } from 'api/users'
import NotificationSys from 'components/NotificationSystem'
import { useCallback } from 'react'
import { useMutation } from 'react-query'
import { UserPasswordSetupLink } from '../UserPasswordSetupLink'

interface UserAdminWelcomeButtonsProps {
  userId: number
  isEmailDirty: boolean
  isFormSubmitting: boolean
}

export function UserAdminWelcomeButtons({
  userId,
  isEmailDirty,
  isFormSubmitting,
}: UserAdminWelcomeButtonsProps) {
  const userEmailMutation = useMutation(resendWelcomeEmail)

  const handleResendWelcomeEmail = useCallback(async () => {
    await userEmailMutation.mutateAsync({
      id: userId,
    })
    NotificationSys.showSuccess('Welcome email was sent')
  }, [userId, userEmailMutation])

  return (
    <>
      <Stack direction="row" spacing={2}>
        <LoadingButton
          type="button"
          variant="contained"
          color="secondary"
          loading={userEmailMutation.isLoading}
          disabled={isEmailDirty || isFormSubmitting || userEmailMutation.isLoading}
          sx={{ width: '220px' }}
          onClick={handleResendWelcomeEmail}
        >
          Resend Welcome Mail
        </LoadingButton>

        <UserPasswordSetupLink userId={userId} disabled={isEmailDirty || isFormSubmitting} />
      </Stack>
    </>
  )
}
